import Pagination from "react-bootstrap/Pagination";

function Paginations() {
  return (
    <Pagination>
      <Pagination.Prev />
      <Pagination.Item>{1}</Pagination.Item>
      <Pagination.Item>{2}</Pagination.Item>

      <Pagination.Next />
    </Pagination>
  );
}

export default Paginations;
